import styled, { css } from 'styled-components';

import { VioletFrameProps } from './VioletFrame';

import { maxWidth } from '@utils/helpers';

const primaryPaddingCss = css`
    padding: 50px 54px;
`;

const secondaryPaddingCss = css`
    padding: 32px 32px 40px;
`;

const paddingVariants = {
    primary: primaryPaddingCss,
    secondary: secondaryPaddingCss,
};

export const VioletFrameWrapper = styled.div<{
    paddingVariant: NonNullable<VioletFrameProps['paddingVariant']>;
}>(
    ({ paddingVariant, theme: { palette, radius } }) => css`
        background-color: ${palette.tertiary.background};
        border-radius: ${radius[8]}px;
        max-width: 544px;
        width: 100%;

        ${paddingVariants[paddingVariant]}

        ${maxWidth('lg')} {
            max-width: unset;
            padding: 32px;
        }

        ${maxWidth('md')} {
            padding: 32px 24px;
        }
    `,
);
